import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { EsignaturLanguageDropdown } from '../esignatur-language-dropdown/esignatur-language-dropdown';
import { BrandSetting } from '@app/brand-settings/brand-setting-service/brand-setting';

/**
 * Application header component.
 *
 * Displays the Esignatur logo and language selector in a primary-colored header bar.
 * Provides consistent branding and navigation across the application.
 *
 * @example
 * Basic usage:
 * ```html
 * <esignatur-header />
 * ```
 */
@Component({
  selector: 'esignatur-header',
  templateUrl: './esignatur-header.html',
  styleUrl: './esignatur-header.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [EsignaturLanguageDropdown],
})
export class EsignaturHeader {
  brandSetting = inject(BrandSetting);
  imageSrc = computed(() => this.brandSetting.brandingConfig().logo!.logoSrc);
}
